import { Injectable } from '@angular/core';

import { LoginService } from '../../core/service/login.service';

@Injectable()

export class MenuService {

    entries: Array<any>;

    constructor(private login: LoginService) {
        this.entries = [];
    }

    add(items: Array<{
        text: string,
        heading?: boolean,
        link?: string,     // internal route links
        elink?: string,    // used only for external links
        target?: string,   // anchor target="_blank|_self|_parent|_top|framename"
        icon?: string,
        alert?: string,
        submenu?: Array<any>,
        permission?: string
    }>) {
        let iitems = this.items;
        let service = this.login;
        let permission: string;

        //AG20220819
        if (iitems.length > 0) {
            iitems.length = 0;
        }
        items.forEach((item) => {
            permission = item.permission;
            if (!permission || service.hasPermission(permission)) {
                iitems.push(item);
            }
        });
    }
    get items() {
        return this.entries;
    }

}
